/** Compiled into this client's assets; server releases never relabel an installed copy. */
export const BUILT_RELEASE_VERSION: string = __APP_VERSION__;
